<mat-horizontal-stepper [linear]="true" #stepper>
  <mat-step form [stepControl]="form">
    <form [formGroup]="form" class="w-full">
      <ng-template matStepLabel>{{
        projectId ? ("UPDATE_PROJECT" | translate) : ("ADD_PROJECT" | translate)
      }}</ng-template>
      <div class="grid grid-cols-12 gap-6">
        <div class="col-span-6">
          <mat-label>{{'ORG_NAME' | translate}}</mat-label>

          <mat-form-field appearance="outline">
            <input matInput formControlName="company_name" readonly />
          </mat-form-field>
        </div>

        <div class="col-span-6">
          <mat-label> {{'companyCode' | translate}}</mat-label>

          <mat-form-field appearance="outline">
            <input matInput formControlName="company_code" readonly />
          </mat-form-field>
        </div>
        <div class="col-span-12">
          <mat-label>{{ "PROJECT_NAME" | translate }}</mat-label>

          <mat-form-field appearance="outline" class="w-full">
            <input matInput formControlName="project_name" *ngIf="!proShow" readonly />
            <mat-select *ngIf="proShow"
              formControlName="project_id"
              (selectionChange)="onProjectChange($event.value)"
            >
              <mat-option value="">{{
                "SELECT_Project" | translate
              }}</mat-option>
              <mat-option
                *ngFor="let project of projectList"
                [value]="project.id"
                >{{ project.project_name }}</mat-option
              >
            </mat-select>
            <mat-error *ngIf="form.get('project_name')?.hasError('required')">
              {{ "PROJECT_NAME_REQUIRED" | translate }}
            </mat-error>
          </mat-form-field>
        </div>

        <div class="col-span-6" *ngIf="branchShow">
          <mat-label
            >{{ "BRANCH" | translate }} <span class="red">*</span></mat-label
          >
          <mat-form-field appearance="outline">
            <mat-select
              formControlName="branch_id"
              (selectionChange)="onBranchChange($event.value)"
            >
              <mat-option value="">{{
                "SELECT_BRANCH" | translate
              }}</mat-option>
              <mat-option
                *ngFor="let branch of branchList"
                [value]="branch.branch_id"
                >{{ branch.branch_name }}</mat-option
              >
            </mat-select>
            <mat-error *ngIf="form.get('branch_id')?.hasError('required')">
              {{ "BRANCH_REQUIRED" | translate }}
            </mat-error>
          </mat-form-field>
        </div>
        <!-- <div class="col-span-6" *ngIf="branchShow">
          <mat-label>{{ "PROJECT_OWNER" | translate }}</mat-label>
          <mat-form-field appearance="outline" class="w-full">
            <input matInput formControlName="owner" readonly />

            <mat-error *ngIf="form.get('owner')?.hasError('required')">
              {{ "PROJECT_MANAGER_REQUIRED" | translate }}
            </mat-error>
          </mat-form-field>
        </div> -->

        <div class="col-span-6">
          <mat-label>{{ "DOMAIN" | translate }}</mat-label>
          <mat-form-field appearance="outline" class="col-span-2">
            <mat-select
              formControlName="domain"
              (selectionChange)="onDomainChange($event.value)"
            >
              <mat-option *ngFor="let domain of domainOptions" [value]="domain">
                {{ domain }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <ng-container *ngFor="let field of domainFields[selectedDomain]">
          <div class="col-span-4">
            <mat-label>{{ field.key | translate}}</mat-label>

            <mat-form-field appearance="outline" *ngIf="form.get(field.key)">
              <input
                matInput
                [type]="field.type"
                [formControlName]="field.key"
              />
            </mat-form-field>
          </div>
        </ng-container>

        <div class="col-span-6">
          <mat-label> {{ "scopeDefinition" | translate }}</mat-label>

          <mat-form-field appearance="outline" class="w-full">
            <input matInput formControlName="scopeDefinition" />

            <mat-error
              *ngIf="form.get('scopeDefinition')?.hasError('required')"
            >
              {{ "DESCRIPTION_REQUIRED" | translate }}
            </mat-error>
          </mat-form-field>
        </div>
        <div class="col-span-6">
          <mat-label> {{ "FeasibilityAssessment" | translate }}</mat-label>

          <mat-form-field appearance="outline" class="w-full">
            <input matInput formControlName="feasibilityAssessment" />

            <mat-error
              *ngIf="form.get('feasibilityAssessment')?.hasError('required')"
            >
              {{ "DESCRIPTION_REQUIRED" | translate }}
            </mat-error>
          </mat-form-field>
        </div>
        <div class="col-span-6">
          <mat-label> {{ "ConceptualDesign" | translate }}</mat-label>

          <mat-form-field appearance="outline" class="w-full">
            <input matInput formControlName="conceptualDesign" />

            <mat-error
              *ngIf="form.get('conceptualDesign')?.hasError('required')"
            >
              {{ "DESCRIPTION_REQUIRED" | translate }}
            </mat-error>
          </mat-form-field>
        </div>
        <div class="col-span-6">
          <mat-label> {{ "fundingSource" | translate }}</mat-label>

          <mat-form-field appearance="outline" class="w-full">
            <input matInput formControlName="fundingSource" />

            <mat-error *ngIf="form.get('fundingSource')?.hasError('required')">
              {{ "DESCRIPTION_REQUIRED" | translate }}
            </mat-error>
          </mat-form-field>
        </div>

        <div class="col-span-6">
          <mat-label> {{ "START_DATE_" | translate }}</mat-label>

          <mat-form-field appearance="outline" class="w-full">
            <input
              matInput
              [matDatepicker]="startPicker"
              formControlName="start_date"
              [max]="cValue"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="startPicker"
            ></mat-datepicker-toggle>
            <mat-datepicker #startPicker></mat-datepicker>

            <mat-error *ngIf="form.get('start_date')?.hasError('required')">
              {{ "START_DATE_REQUIRED" | translate }}
            </mat-error>
          </mat-form-field>
        </div>

        <div class="col-span-6">
          <mat-label>{{ "END_DATE_" | translate }} </mat-label>

          <mat-form-field appearance="outline" class="w-full">
            <input
              matInput
              [matDatepicker]="endPicker"
              formControlName="end_date"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="endPicker"
            ></mat-datepicker-toggle>
            <mat-datepicker #endPicker></mat-datepicker>

            <mat-error *ngIf="form.get('end_date')?.hasError('required')">
              {{ "END_DATE_REQUIRED" | translate }}
            </mat-error>
          </mat-form-field>
        </div>

        <div class="col-span-6">
          <mat-label> {{ "STATUS" | translate }}</mat-label>

          <mat-form-field appearance="outline" class="w-full">
            <mat-select formControlName="status">
              <mat-option value="">Select Status</mat-option>
              <mat-option
                *ngFor="let status of statusList_"
                [value]="status.id"
                >{{ status.status }}</mat-option
              >
            </mat-select>

            <mat-error *ngIf="form.get('status')?.hasError('required')">
              {{ "STATUS_REQUIRED" | translate }}
            </mat-error>
          </mat-form-field>
        </div>

        <div class="col-span-6">
          <mat-label>{{ "BUDGET" | translate }} </mat-label>
          <mat-form-field appearance="outline" class="w-full">
            <input matInput formControlName="budget_amount" />

            <mat-error *ngIf="form.get('budget_amount')?.hasError('required')">
              {{ "BUDGET_REQUIRED" | translate }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>

      <div class="w-full flex justify-end mt-6">
        <button
          mat-raised-button
          color="primary"
          matStepperNext
          [disabled]="!form.valid"
        >
          {{ "NEXT" | translate }}
        </button>
      </div>
    </form>
  </mat-step>
  <mat-step userCForm [stepControl]="userCForm" *ngIf="false">
    <form [formGroup]="userCForm">
      <ng-template matStepLabel>Users</ng-template>

      <div formArrayName="contacts">
        <div
          *ngFor="let contact of contacts.controls; let i = index"
          [formGroupName]="i"
          class="contact-group"
        >
          <div class="flex flex-row gap-4">
            <div class="half-width">
              <mat-label>Name</mat-label>
              <mat-form-field appearance="outline" class="w-full">
                <mat-select formControlName="name">
                  <mat-option value="">Select Name</mat-option>
                  <mat-option
                    *ngFor="let user of staffList"
                    [value]="user?.id"
                    >{{ user?.full_name }}</mat-option
                  >
                </mat-select>
                <mat-error *ngIf="contact.get('name')?.hasError('required')">
                  Name is required
                </mat-error>
              </mat-form-field>
            </div>
            <div class="half-width">
              <mat-label>Start Date</mat-label>

              <mat-form-field appearance="outline" class="w-full">
                <input
                  matInput
                  [matDatepicker]="startPicker"
                  formControlName="start_date"
                  [max]="cValue"
                />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="startPicker"
                ></mat-datepicker-toggle>
                <mat-datepicker #startPicker></mat-datepicker>
                <mat-error
                  *ngIf="contact.get('start_date')?.hasError('required')"
                >
                  Start Date is required
                </mat-error>
              </mat-form-field>
            </div>

            <div class="half-width">
              <mat-label>End Date</mat-label>

              <mat-form-field appearance="outline" class="w-full">
                <input
                  matInput
                  [matDatepicker]="endPicker"
                  formControlName="end_date"
                />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="endPicker"
                ></mat-datepicker-toggle>
                <mat-datepicker #endPicker></mat-datepicker>
                <mat-error
                  *ngIf="contact.get('end_date')?.hasError('required')"
                >
                  End Date is required
                </mat-error>
              </mat-form-field>
            </div>
          </div>

          <div class="form-actions" style="margin-bottom: 10px">
            <button
              *ngIf="contacts.length > 1"
              mat-raised-button
              color="warn"
              style="margin-right: 5px"
              color="warn"
              type="button"
              (click)="removeContact(i)"
              [disabled]="contacts.length === 1"
            >
              Remove
            </button>
            <button
              mat-raised-button
              color="primary"
              type="button"
              (click)="addContact()"
            >
              Add User
            </button>
          </div>
        </div>
      </div>
    </form>
    <div class="form-actions" style="float: right">
      <button mat-button matStepperPrevious>Back</button>
      <button
        mat-raised-button
        color="primary"
        matStepperNext
        [disabled]="!userCForm.valid"
      >
        Next
      </button>
    </div>
  </mat-step>
  <mat-step userGForm [stepControl]="userGForm" *ngIf="false">
    <form [formGroup]="userGForm">
      <ng-template matStepLabel>Materials</ng-template>

      <div formArrayName="materials">
        <div
          *ngFor="let material of materials.controls; let i = index"
          [formGroupName]="i"
          class="contact-group"
        >
          <div class="flex flex-row gap-4">
            <div class="half-width">
              <mat-label>Material Name</mat-label>
              <mat-form-field appearance="outline" class="w-full">
                <mat-select formControlName="name">
                  <mat-option value="">Select Material</mat-option>
                  <mat-option
                    *ngFor="let m of machineData"
                    [value]="m?.equipment_id"
                    >{{ m?.equipment_name }}</mat-option
                  >
                </mat-select>
                <mat-error *ngIf="material.get('name')?.hasError('required')">
                  Name is required
                </mat-error>
              </mat-form-field>
            </div>
            <div class="half-width">
              <mat-label>Start Date</mat-label>

              <mat-form-field appearance="outline" class="w-full">
                <input
                  matInput
                  [matDatepicker]="startPicker"
                  formControlName="start_date"
                  [max]="cValue"
                />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="startPicker"
                ></mat-datepicker-toggle>
                <mat-datepicker #startPicker></mat-datepicker>
                <mat-error
                  *ngIf="material.get('start_date')?.hasError('required')"
                >
                  Start Date is required
                </mat-error>
              </mat-form-field>
            </div>

            <div class="half-width">
              <mat-label>End Date</mat-label>

              <mat-form-field appearance="outline" class="w-full">
                <input
                  matInput
                  [matDatepicker]="endPicker"
                  formControlName="end_date"
                />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="endPicker"
                ></mat-datepicker-toggle>
                <mat-datepicker #endPicker></mat-datepicker>
                <mat-error
                  *ngIf="material.get('end_date')?.hasError('required')"
                >
                  End Date is required
                </mat-error>
              </mat-form-field>
            </div>
          </div>

          <div class="form-actions" style="margin-bottom: 10px">
            <button
              *ngIf="materials.length > 1"
              mat-raised-button
              color="warn"
              style="margin-right: 5px"
              color="warn"
              type="button"
              (click)="removeM(i)"
              [disabled]="materials.length === 1"
            >
              Remove
            </button>
            <button
              mat-raised-button
              color="primary"
              type="button"
              (click)="addM()"
            >
              Add Material
            </button>
          </div>
        </div>
      </div>
    </form>
    <div class="form-actions" style="float: right">
      <button mat-button matStepperPrevious>Back</button>
      <button
        mat-raised-button
        color="primary"
        matStepperNext
        [disabled]="!userGForm.valid"
      >
        Next
      </button>
    </div>
  </mat-step>
  <mat-step docform [stepControl]="docform" *ngIf="false">
    <form [formGroup]="docform" class="w-full">
      <ng-template matStepLabel>Project File</ng-template>
      <div formArrayName="documents">
        <div
          *ngFor="let doc of documents.controls; let i = index"
          [formGroupName]="i"
        >
          <div class="grid grid-cols-12 gap-6">
            <div class="col-span-6">
              <mat-label>Document Name</mat-label>
              <mat-form-field appearance="outline" class="w-full">
                <input matInput formControlName="doc_name" />
                <mat-error
                  *ngIf="submitted && doc.get('doc_name')?.errors?.['required']"
                >
                  Document Name is required
                </mat-error>
              </mat-form-field>
            </div>

            <div class="col-span-6">
              <mat-label>Upload File</mat-label>
              <mat-form-field appearance="outline" class="w-full">
                <input
                  matInput
                  [value]="doc.get('file_name')?.value || ''"
                  placeholder="Choose file"
                  readonly
                />
                <button
                  mat-icon-button
                  matSuffix
                  (click)="triggerFileInput(i)"
                  type="button"
                >
                  <mat-icon>upload</mat-icon>
                </button>
              </mat-form-field>
              <input
                type="file"
                hidden
                #fileInput
                (change)="onFileSelected($event, i)"
              />
              <mat-error
                *ngIf="submitted && doc.get('file')?.errors?.['required']"
              >
                File is required
              </mat-error>
            </div>
          </div>
          <div class="form-actions" style="margin-bottom: 10px">
            <button
              mat-raised-button
              color="warn"
              style="margin-right: 5px"
              color="warn"
              type="button"
              (click)="removeDoc(i)"
            >
              Remove
            </button>
            <button
              mat-raised-button
              color="primary"
              type="button"
              (click)="addDoc()"
            >
              Add Doc
            </button>
          </div>
        </div>
      </div>
    </form>
    <div class="w-full flex justify-end mt-6">
      <div class="form-actions" style="float: right">
        <button mat-button matStepperPrevious>Back</button>
        <button
          mat-raised-button
          color="primary"
          matStepperNext
          [disabled]="!docform.valid"
        >
          Next
        </button>
      </div>
    </div>
  </mat-step>
  <mat-step [stepControl]="locationForm">
    <form [formGroup]="locationForm" class="w-full">
      <ng-template matStepLabel>{{ "LOCATION" | translate }}</ng-template>

      <div formArrayName="location">
        <div
          *ngFor="let branch of location.controls; let i = index"
          [formGroupName]="i"
        >
          <div class="flex flex-row gap-4">
            <div class="half-width">
              <mat-label>{{ "COUNTRY" | translate }}</mat-label>
              <mat-form-field appearance="outline" class="half-width">
                <mat-select
                  formControlName="country"
                  (selectionChange)="onCountryBChange(i)"
                  required
                >
                  <mat-option value="">{{
                    "SELECT_COUNTRY" | translate
                  }}</mat-option>
                  <mat-option value="India">India</mat-option>
                </mat-select>
                <mat-error *ngIf="branch.get('country')?.hasError('required')">
                  {{ "COUNTRY_REQUIRED" | translate }}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="half-width">
              <mat-label>{{ "STATE" | translate }}</mat-label>
              <mat-form-field appearance="outline">
                <mat-select
                  formControlName="state"
                  (selectionChange)="onStateBChange(i)"
                  required
                >
                  <mat-option value="">{{
                    "SELECT_STATE" | translate
                  }}</mat-option>
                  <mat-option
                    *ngFor="let state of availableStates[i]"
                    [value]="state"
                  >
                    {{ state }}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="branch.get('state')?.hasError('required')">
                  {{ "STATE_REQUIRED" | translate }}
                </mat-error>
              </mat-form-field>
            </div>
          </div>

          <div class="flex flex-row gap-4">
            <div class="half-width">
              <mat-label>{{ "CITY" | translate }}</mat-label>
              <mat-form-field appearance="outline">
                <mat-select formControlName="city" required>
                  <mat-option value="">{{
                    "SELECT_CITY" | translate
                  }}</mat-option>
                  <mat-option
                    *ngFor="let city of availableCities[i]"
                    [value]="city"
                  >
                    {{ city }}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="branch.get('city')?.hasError('required')">
                  {{ "CITY_REQUIRED" | translate }}
                </mat-error>
              </mat-form-field>
            </div>

            <div class="half-width">
              <mat-label>{{ "POSTAL_CODE" | translate }}</mat-label>
              <mat-form-field appearance="outline">
                <input
                  matInput
                  placeholder="Pincode"
                  formControlName="pincode"
                />
                <mat-error *ngIf="branch.get('pincode')?.hasError('required')">
                  {{ "PINCODE_REQUIRED" | translate }}
                </mat-error>
              </mat-form-field>
            </div>
          </div>
          <div class="flex flex-row gap-4">
            <div class="half-width">
              <mat-label> {{ "line1" | translate }}</mat-label>

              <mat-form-field appearance="outline">
                <input matInput formControlName="address_line_1" />
                <mat-error
                  *ngIf="branch.get('address_line_1')?.hasError('required')"
                >
                  {{ "employee.address" | translate }}
                  {{ "REQUIRED" | translate }}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="half-width">
              <mat-label> {{ "line2" | translate }}</mat-label>

              <mat-form-field appearance="outline">
                <input matInput formControlName="address_line_2" />
                <mat-error
                  *ngIf="branch.get('address_line_2')?.hasError('required')"
                >
                  {{ "employee.address" | translate }}
                  {{ "REQUIRED" | translate }}
                </mat-error>
              </mat-form-field>
            </div>
          </div>
          <button
            mat-stroked-button
            type="button"
            (click)="openPicker(i, branch)"
          >
            {{ "locateOnMap" | translate }}
          </button>

          <div class="flex flex-row gap-4">
            <div class="half-width">
              <mat-label>{{ "LAT" | translate }}</mat-label>

              <mat-form-field appearance="outline">
                <input matInput placeholder="Latitude" formControlName="lat" />
                <mat-error *ngIf="branch.get('lat')?.hasError('required')">
                  {{ "LAT_REQUIRED" | translate }}
                </mat-error>
              </mat-form-field>
            </div>
            <div>
              <mat-label>{{ "LONG" | translate }}</mat-label>
              <mat-form-field appearance="outline">
                <input matInput formControlName="long" />
                <mat-error *ngIf="branch.get('long')?.hasError('required')">
                  {{ "LONG_REQUIRED" | translate }}
                </mat-error>
              </mat-form-field>
            </div>
          </div>

          <div *ngIf="false" class="form-actions mt-4 flex gap-4">
            <button
              *ngIf="location.length > 1"
              mat-raised-button
              color="warn"
              type="button"
              (click)="removeBranch(i)"
            >
              {{ "REMOVE" | translate }}
            </button>
            <button
              mat-raised-button
              color="primary"
              type="button"
              (click)="addBranch()"
            >
              {{ "ADD_BRANCH" | translate }}
            </button>
          </div>

          <mat-divider class="my-4"></mat-divider>
        </div>
      </div>

      <div class="w-full flex justify-end mt-6">
        <button mat-button matStepperPrevious>{{ "BACK" | translate }}</button>
        <button
          mat-raised-button
          color="primary"
          matStepperNext
          [disabled]="!locationForm.valid"
        >
          {{ "NEXT" | translate }}
        </button>
      </div>
    </form>
  </mat-step>

  <mat-step clientForm [stepControl]="clientForm">
    <form [formGroup]="clientForm" class="w-full">
      <ng-template matStepLabel>{{ "CLIENT" | translate }}</ng-template>

      <div class="grid grid-cols-12 gap-6">
        <!-- Client Name -->
        <div class="col-span-6">
          <mat-label>{{ "CLIENT_NAME" | translate }}</mat-label>
          <mat-form-field appearance="outline" class="w-full">
            <input matInput formControlName="client_name" />
            <mat-error
              *ngIf="clientForm.get('client_name')?.hasError('required')"
            >
              {{ "CLIENT_REQUIRED" | translate }}
            </mat-error>
          </mat-form-field>
        </div>

        <!-- Client Person -->
        <div class="col-span-6">
          <mat-label>{{ "CLIENT_PERSON" | translate }}</mat-label>
          <mat-form-field appearance="outline" class="w-full">
            <input matInput formControlName="contact_person" />
            <mat-error
              *ngIf="clientForm.get('contact_person')?.hasError('required')"
            >
              {{ "CLIENT_PERSON_REQUIRED" | translate }}
            </mat-error>
          </mat-form-field>
        </div>

        <!-- Client Number -->
        <div class="col-span-6">
          <mat-label>{{ "CLIENT_NUMBER" | translate }}</mat-label>
          <mat-form-field appearance="outline" class="w-full">
            <input matInput formControlName="contact_number" />
            <mat-error
              *ngIf="clientForm.get('contact_number')?.hasError('required')"
            >
              {{ "CLIENT_NUMBER_REQUIRED" | translate }}
            </mat-error>
          </mat-form-field>
        </div>
        <!-- Client Number -->
        <div class="col-span-6">
          <mat-label>{{ "Khasra_no" | translate }}</mat-label>
          <mat-form-field appearance="outline" class="w-full">
            <input matInput formControlName="khasra_no" />
          </mat-form-field>
        </div>
        <div class="col-span-6">
          <mat-label>{{ "Area" | translate }}</mat-label>
          <mat-form-field appearance="outline" class="w-full">
            <input matInput formControlName="area" />
          </mat-form-field>
        </div>
        <!-- State -->
        <div class="col-span-6">
          <mat-label>{{ "STATE" | translate }}</mat-label>
          <mat-form-field appearance="outline" class="w-full">
            <mat-select
              formControlName="state"
              (selectionChange)="getdistricts()"
            >
              <mat-option value="">{{ "SELECT_STATE" | translate }}</mat-option>
              <mat-option *ngFor="let state of allState" [value]="state">{{
                state
              }}</mat-option>
            </mat-select>
            <mat-error *ngIf="clientForm.get('state')?.hasError('required')">
              {{ "STATE_REQUIRED" | translate }}
            </mat-error>
          </mat-form-field>
        </div>

        <!-- District -->
        <div class="col-span-6">
          <mat-label>{{ "DISTRICT" | translate }}</mat-label>
          <mat-form-field appearance="outline" class="w-full">
            <mat-select
              formControlName="district"
              (selectionChange)="getsubdistricts()"
            >
              <mat-option value="">{{
                "SELECT_DISTRICT" | translate
              }}</mat-option>
              <mat-option
                *ngFor="let district of allDistricts"
                [value]="district"
                >{{ district }}</mat-option
              >
            </mat-select>
            <mat-error *ngIf="clientForm.get('district')?.hasError('required')">
              {{ "DISTRICT_REQUIRED" | translate }}
            </mat-error>
          </mat-form-field>
        </div>

        <!-- SubDistrict -->
        <div class="col-span-6">
          <mat-label>{{ "SUBDISTRICT" | translate }}</mat-label>
          <mat-form-field appearance="outline" class="w-full">
            <mat-select
              formControlName="sub_district"
              (selectionChange)="getvillages()"
            >
              <mat-option value="">{{
                "SELECT_SUBDISTRICT" | translate
              }}</mat-option>
              <mat-option
                *ngFor="let subdistrict of allSubDistricts"
                [value]="subdistrict"
                >{{ subdistrict }}</mat-option
              >
            </mat-select>
            <mat-error
              *ngIf="clientForm.get('sub_district')?.hasError('required')"
            >
              {{ "SUBDISTRICT_REQUIRED" | translate }}
            </mat-error>
          </mat-form-field>
        </div>

        <!-- Villages -->
        <div class="col-span-6">
          <mat-label>{{ "VILLAGES" | translate }}</mat-label>
          <mat-form-field appearance="outline" class="w-full">
            <mat-select formControlName="villages">
              <mat-option value="">{{
                "SELECT_VILLAGE" | translate
              }}</mat-option>
              <mat-option
                *ngFor="let village of allVillage"
                [value]="village"
                >{{ village }}</mat-option
              >
            </mat-select>
            <mat-error *ngIf="clientForm.get('villages')?.hasError('required')">
              {{ "VILLAGES_REQUIRED" | translate }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>

      <div class="w-full flex justify-end mt-6">
        <button mat-button matStepperPrevious>{{ "BACK" | translate }}</button>
        <button
          mat-raised-button
          color="primary"
          type="submit"
          class="w-60"
          (click)="onSubmit()"
        >
          {{
            projectId
              ? ("UPDATE_PROJECT" | translate)
              : ("SAVE_PROJECT" | translate)
          }}
        </button>
      </div>
    </form>
  </mat-step>
</mat-horizontal-stepper>
